<form class="search-input-form" [formGroup]="searchFilterForm">
    <tui-input
        formControlName="searchControl"
        (ngModelChange)="onSearchChange()"
        [tuiTextfieldCleaner]="true"
        tuiTextfieldIconLeft="@tui.search"
    >
        Search
        <input tuiTextfieldLegacy />
    </tui-input>
</form>
